import React, { memo } from 'react';
import {
  Box,
  ButtonIcon,
  Icon,
  Link as DSLink,
  Typography,
} from '@saviynt/design-system';

import { CF_NEU_BLD, CF_NEU_MED } from '../../../../../shared/constants';
import {
  type NavigateToDetailsProps,
  useInvertedLocalize,
} from '../../../../../shared/hooks';

interface RemediationHeaderProps {
  subtitlelinkText: string;
  handleClose: () => void;
  redirectTo?: NavigateToDetailsProps;
  onRedirect: () => void;
}

/**
 * RemediationHeader
 */
function RemediationHeader({
  subtitlelinkText,
  handleClose,
  redirectTo,
  onRedirect,
}: RemediationHeaderProps) {
  const l = useInvertedLocalize();
  const violationText = `${l('Violation')}:`;

  return (
    <div className='Sod-RemediateActionModal-headerWrapper'>
      <Box tag='div' className='Sod-RemediateActionModal-headerBox'>
        <Box tag='div' className='Sod-RemediateActionModal-header'>
          <Icon kind='SodRemediate' size='large' color={CF_NEU_BLD} />
          <Box tag='div' className='Sod-RemediateActionModal-headerText'>
            <Typography kind='h1' color={CF_NEU_BLD}>
              {l('Remediate')}
            </Typography>
            {redirectTo && (
              <Box
                tag='div'
                className='Sod-RemediateActionModal-headerSubtitle'>
                <Typography kind='body2' color={CF_NEU_MED}>
                  {violationText}
                </Typography>
                <DSLink
                  kind='button'
                  text={subtitlelinkText}
                  color='neutral'
                  target='_self'
                  onClick={onRedirect}
                  size='medium'
                />
              </Box>
            )}
          </Box>
        </Box>
      </Box>
      <ButtonIcon
        size='large'
        kind='ghost'
        ariaLabel={l('Close')}
        icon={<Icon kind='Close' size='medium' />}
        onClick={handleClose}
        className='Sod-RemediateActionModal-closeButton'
      />
    </div>
  );
}

RemediationHeader.defaultProps = {
  redirectTo: () => {},
};

export default memo(RemediationHeader);
